import { z } from 'zod'

export default z.object({
  __typename: z.literal('Contract').default('Contract'),
  id: z.number(),
})
